'use client';

import type { ComponentProps } from 'react';
import { useShouldShowWalletBalance } from './hooks';

type WalletBalanceProps = ComponentProps<'span'>;

/**
 * WalletBalance component displays the user's wallet balance if the user is not on a game page or if the user is on a mobile device.
 * This component extends HTMLSpanElement props.
 * @returns A span element with the user's wallet balance if the user is not on a game page or if the user is on a mobile device, otherwise null.
 */
function WalletBalance({ ...props }: WalletBalanceProps) {
  const showWalletBalance = useShouldShowWalletBalance();
  return showWalletBalance ? <span {...props} /> : null;
}

export { WalletBalance };
